import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInbox = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 365 275",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_f_14014_10452",
			width: 201.008,
			height: 201.008,
			x: 163.873,
			y: .479,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					mode: "normal",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					result: "effect1_foregroundBlur_14014_10452",
					stdDeviation: 3
				})
			]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "filter1_f_14014_10452",
			width: 133.49,
			height: 133.489,
			x: .076,
			y: 141.119,
			colorInterpolationFilters: "sRGB",
			filterUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					mode: "normal",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					result: "effect1_foregroundBlur_14014_10452",
					stdDeviation: 3
				})
			]
		})] }),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_14014_10452)",
			opacity: .8,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 94.504,
				cy: 94.504,
				r: 94.504,
				fill: "#86DED7",
				transform: "matrix(-1 0 .00126 1 358.762 6.479)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_f_14014_10452)",
			opacity: .8,
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 60.745,
				cy: 60.745,
				r: 60.745,
				fill: "#AEAEFF",
				transform: "matrix(-1 0 .00126 1 127.49 147.119)"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#8043FF",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M176.561 255.286c61.541 0 111.43-49.889 111.43-111.43 0-61.541-49.889-111.43-111.43-111.43-61.541 0-111.43 49.889-111.43 111.43 0 61.541 49.889 111.43 111.43 111.43z" }),
				/* @__PURE__ */ _jsx("path", { d: "M231.89 106.187h-.016l-39.31 37.762 39.125 37.577h.201v-36.354" }),
				/* @__PURE__ */ _jsx("path", { d: "M192.563 106.187h-71.315l39.31 37.762 16.003 15.383 16.002-15.383 39.31-37.762" })
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 3,
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M192.565 143.948l-16.003 15.384-16.002-15.384-39.124 37.577h110.253l-11.7-11.236-27.424-26.341z" }),
				/* @__PURE__ */ _jsx("path", { d: "M121.25 106.187h-.016v75.339h.202l39.124-37.577-39.31-37.762z" }),
				/* @__PURE__ */ _jsx("path", { d: "M231.89 106.187h-.016l-39.31 37.762 39.125 37.577h.201v-36.354" }),
				/* @__PURE__ */ _jsx("path", { d: "M192.563 106.187h-71.315l39.31 37.762 16.003 15.383 16.002-15.383 39.31-37.762" })
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#200063",
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 3,
			d: "M231.89 132.125c14.325 0 25.938-11.613 25.938-25.939 0-14.325-11.613-25.938-25.938-25.938-14.326 0-25.939 11.613-25.939 25.938 0 14.326 11.613 25.939 25.939 25.939z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M235.879 94v23.118h-5.154V98.639h-.143L225 101.958v-4.334L231.035 94z"
		})
	]
});
export default SvgInbox;
